import { GiTyre } from "react-icons/gi";
import TableComponent from "../TableComponent";

const RecentlyInstalledTires = ({ items }) => {
  const header = [
    { value: "service_short_info.service_id", label: "ID" },
    { value: "vehicle.registration_number", label: "Vehcile" },
    { value: "service_short_info.complete_at", label: "Completion Date" },
    { value: "service_short_info.status", label: "Status" },
  ];
  return (
    <div className="card_container">
      <TableComponent
        heading="Recently Installed Tyres"
        icon={<GiTyre />}
        columns={header}
        data={items}
        currentPage={1}
      />
    </div>
  );
};

export default RecentlyInstalledTires;
